import {
  parseHeldAdminRequests,
  parseListerItems,
} from "@p0security/integrations-databricks-shared/api";
import type { DatabricksIntegration } from "@p0security/integrations-databricks-shared/types";
import type { FrontendInstallContext } from "@p0security/integrations-installer";
import { installedIds } from "@p0security/shared/install/installed";

export type InstallContext = FrontendInstallContext<DatabricksIntegration>;

export const errorMessage = (error: unknown) =>
  error instanceof Error ? error.message : String(error);

/** How an item is named in a list: its label and key, or just its key. */
export const itemLabel = (key: string, label?: string) =>
  label ? `${label} (${key})` : key;

/** The keys of the installed `component` items. */
export const installedKeys = (
  context: InstallContext,
  component: keyof DatabricksIntegration
) =>
  // The integration's config is loaded live, so it may not be here yet.
  new Set(context.config ? installedIds(component, context.config) : []);

/**
 * A route's response, parsed with `parse`. One P0 can't read is P0's own bug,
 * which the customer can't fix, so it's also logged as an error, which
 * CaptureConsole sends to Sentry. The API's refusals aren't: the customer
 * can act on them, and the API logged them already.
 */
const readResponse = async <T>(
  response: Response,
  parse: (body: unknown) => T
) => {
  try {
    return parse(await response.json());
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/** The items in the catalogs route's response. */
export const readListerItems = async (response: Response) =>
  await readResponse(response, parseListerItems);

/** The request IDs in the held admin requests route's response. */
export const readHeldAdminRequests = async (response: Response) =>
  await readResponse(response, parseHeldAdminRequests);
